<template>
  <div class="map-picker">
    <div class="search-box">
      <div class="search-input-wrapper">
        <input v-model="searchKeyword" type="text" placeholder="搜索地点..." @input="onSearchInput" id="keyword" />
        <button class="confirm-btn" @click="confirmSelection" :disabled="!selectedPoint">确认选择</button>
      </div>
      <ul v-if="searchTips.length > 0" class="search-tips">
        <li v-for="(tip, index) in searchTips" :key="index" @click="onTipClick(tip)">
          {{ tip.name }} - {{ tip.district || tip.address }}
        </li>
      </ul>
    </div>
    <div id="map-container" ref="mapContainer"></div>
    <div v-if="selectedPoint" class="result-panel">
      <h3>已选地点信息</h3>
      <!-- <p><strong>经纬度：</strong> {{ selectedPoint.lnglat.lng.toFixed(6) }}, {{ selectedPoint.lnglat.lat.toFixed(6) }}</p> -->
      <p><strong>地址：</strong> {{ selectedPoint.formattedAddress }}</p>
      <!-- <p><strong>省市区：</strong> {{ selectedPoint.province }} {{ selectedPoint.city }} {{ selectedPoint.district }}</p>
      <p><strong>区域编码（adcode）：</strong> {{ selectedPoint.adcode }}</p>
      <p><strong>省份编码：</strong> {{ selectedPoint.provinceCode || '' }}</p>
      <p><strong>城市编码：</strong> {{ selectedPoint.cityCode || '' }}</p>
      <p><strong>区县编码：</strong> {{ selectedPoint.districtCode || '' }}</p> -->
    </div>
  </div>
</template>

<script>
import AMapLoader from '@amap/amap-jsapi-loader';
window._AMapSecurityConfig = {
  securityJsCode: '9ef2e43bf8314ec9e6b6016e6a1ecb54', // 替换为新的安全密钥
};
export default {
  name: 'MapPicker',
  props: {
    // 接收外部传入的中心位置，格式为 [lng, lat]
    center: {
      type: Array,
      default: () => [116.397428, 39.90923],
      validator: (value) => {
        return value.length === 2 && typeof value[0] === 'number' && typeof value[1] === 'number';
      }
    }
  },
  data() {
    return {
      map: null,
      AMap: null,
      searchKeyword: '',
      searchTips: [],
      selectedPoint: null,
      autoComplete: null,
      geocoder: null,
      marker: null,
      searchTimer: null
    };
  },
  mounted() {
    this.initMap();
  },
  methods: {
    async initMap() {
      try {
        //  使用您的新Key
        this.AMap = await AMapLoader.load({
          key: 'b78c97ff656bc19684df9e29a4694a4c', // 替换为新的Key
          version: '2.0', // 必须与安全密钥配套使用2.0
          plugins: ['AMap.AutoComplete', 'AMap.Geocoder'],
        });

        // 初始化地图，使用传入的中心点
        this.map = new this.AMap.Map(this.$refs.mapContainer, {
          zoom: 11,
          center: this.center,
        });

        // 初始化地理编码器和搜索
        this.geocoder = new this.AMap.Geocoder({ radius: 1000 });
        this.initAutoComplete();

        // 监听点击
        this.map.on('click', this.onMapClick);
        console.log('✅ 地图初始化成功，中心点：', this.center);

        // 如果传入了中心点，自动解析省市区信息
        this.autoResolveCenter();

      } catch (error) {
        console.error('❌ 地图初始化失败:', error);
        alert('地图加载失败，请检查控制台或Key配置。错误：' + error.message);
      }
    },

    // 自动解析传入的中心点的省市区信息
    autoResolveCenter() {
      if (this.center && this.center.length === 2) {
        const [lng, lat] = this.center;
        this.addMarker([lng, lat], '中心点');
        this.reverseGeocode(lng, lat);
      }
    },

    initAutoComplete() {
      // 方法1：绑定到input（简单）
      this.autoComplete = new this.AMap.AutoComplete({
        input: 'keyword' // 请确保模板中input的id="keyword"
      });

      // 监听选择事件
      this.autoComplete.on('select', (e) => {
        if (e.poi && e.poi.location) {
          this.searchTips = [];
          this.searchKeyword = e.poi.name;
          this.map.setCenter(e.poi.location);
          this.map.setZoom(15);
          this.addMarker(e.poi.location, e.poi.name);
          this.reverseGeocode(e.poi.location.lng, e.poi.location.lat);
        }
      });
    },

    onSearchInput() {
      if (!this.searchKeyword.trim()) {
        this.searchTips = [];
        return;
      }
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => {
        this.autoComplete.search(this.searchKeyword.trim(), (status, result) => {
          this.searchTips = (status === 'complete' && result.tips) ? result.tips : [];
        });
      }, 300);
    },

    onTipClick(tip) {
      if (tip.location) {
        this.searchTips = [];
        this.searchKeyword = tip.name;
        this.map.setCenter([tip.location.lng, tip.location.lat]);
        this.map.setZoom(15);
        this.addMarker([tip.location.lng, tip.location.lat], tip.name);
        this.reverseGeocode(tip.location.lng, tip.location.lat);
      }
    },

    onMapClick(event) {
      const lnglat = event.lnglat;
      this.addMarker([lnglat.lng, lnglat.lat], '选中位置');
      this.reverseGeocode(lnglat.lng, lnglat.lat);
    },

    addMarker(position, title) {
      if (this.marker) this.map.remove(this.marker);
      this.marker = new this.AMap.Marker({
        position: position,
        title: title
      });
      this.map.add(this.marker);
    },

    reverseGeocode(lng, lat) {
      if (!this.geocoder) return;

      this.geocoder.getAddress([lng, lat], (status, result) => {
        if (status === 'complete' && result.regeocode) {
          const addr = result.regeocode.addressComponent;

          // 初始化选中点信息，保留原有的adcode字段
          this.selectedPoint = {
            lng: lng,
            lat: lat,
            formattedAddress: result.regeocode.formattedAddress,
            province: addr.province,
            city: addr.city || addr.province,
            district: addr.district,
            adcode: addr.adcode, // 保留原有的adcode字段
            provinceCode: '',    // 新增省份编码
            cityCode: '',        // 新增城市编码
            districtCode: ''     // 新增区县编码
          };

          // 获取省份编码
          this.geocoder.getLocation(addr.province, (provStatus, provResult) => {
            if (provStatus === 'complete' && provResult.geocodes && provResult.geocodes.length > 0) {
              this.selectedPoint.provinceCode = provResult.geocodes[0].adcode.substring(0, 2) + '0000';
              // this.$emit('point-selected', this.selectedPoint);
            }
          });

          // 获取城市编码
          this.geocoder.getLocation(addr.city || addr.province, (cityStatus, cityResult) => {
            if (cityStatus === 'complete' && cityResult.geocodes && cityResult.geocodes.length > 0) {
              this.selectedPoint.cityCode = cityResult.geocodes[0].adcode.substring(0, 4) + '00';
              // this.$emit('point-selected', this.selectedPoint);
            }
          });

          // 区县编码即adcode
          this.selectedPoint.districtCode = addr.adcode;

          // 将选中点的地址回显到搜索框
          this.searchKeyword = this.selectedPoint.formattedAddress;
          // this.$emit('point-selected', this.selectedPoint);
        } else {
          console.error('逆地理编码失败:', result);
          this.selectedPoint = {
            lng: lng,
            lat: lat,
            formattedAddress: '地址解析失败',
            province: '', city: '', district: '', adcode: '',
            provinceCode: '', cityCode: '', districtCode: ''
          };
          // 将失败信息也回显到搜索框
          this.searchKeyword = this.selectedPoint.formattedAddress;
          // this.$emit('point-selected', this.selectedPoint);
        }
      });
    },

    // 确认选择按钮事件（保留原有功能）
    confirmSelection() {
      if (this.selectedPoint) {
        // 发送确认事件给父组件
        this.$emit('pointConfirmed', this.selectedPoint);
      }
    }
  },
  beforeDestroy() {
    if (this.map) this.map.destroy();
    if (this.searchTimer) clearTimeout(this.searchTimer);
  }
};
</script>

<style scoped>
.map-picker {
  width: 100%;
  height: 600px;
  position: relative;
}

.search-box {
  position: absolute;
  top: 20px;
  left: 20px;
  z-index: 10;
  background: white;
  padding: 5px;
  border-radius: 4px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  width: 380px;
}

.search-input-wrapper {
  display: flex;
  gap: 10px;
  align-items: center;
}

.search-input-wrapper input {
  flex: 1;
  padding: 10px;
  box-sizing: border-box;
  border: 1px solid #ddd;
  border-radius: 3px;
  font-size: 14px;
}

.confirm-btn {
  padding: 10px 20px;
  background-color: #1890ff;
  color: white;
  border: none;
  border-radius: 3px;
  cursor: pointer;
  font-size: 14px;
}

.confirm-btn:hover:not(:disabled) {
  background-color: #40a9ff;
}

.confirm-btn:disabled {
  background-color: #d9d9d9;
  cursor: not-allowed;
}

.search-tips {
  list-style: none;
  margin: 5px 0 0 0;
  padding: 0;
  border-top: 1px solid #eee;
  max-height: 200px;
  overflow-y: auto;
}

.search-tips li {
  padding: 8px;
  cursor: pointer;
  border-bottom: 1px solid #f0f0f0;
}

.search-tips li:hover {
  background-color: #f5f5f5;
}

#map-container {
  width: 100%;
  height: 100%;
}

.result-panel {
  position: absolute;
  bottom: 20px;
  left: 20px;
  right: 20px;
  background: white;
  padding: 15px;
  border-radius: 4px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  z-index: 10;
  max-width: 400px;
}
</style>